import { useEffect, useState } from "react";
import { DEFAULT_THEME } from "../config/api.config";

export default function useTheme() {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || DEFAULT_THEME;
  });

  useEffect(() => {
    const root = window.document.documentElement;

    root.classList.remove(DEFAULT_THEME, "dark");

    // add only if theme is not empty
    if (theme) {
      root.classList.add(theme);
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  return [theme, setTheme];
}
